let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j1srk")).then(() => parcelRequire('gs7PQ'));